import { render } from "./VtoFooter.vue?vue&type=template&id=d89afae0"
import script from "./VtoFooter.vue?vue&type=script&lang=js"
export * from "./VtoFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__